// @module TavanoTeam.CapSciExtensions.CSSearchSpringExt
define('TavanoTeam.CapSciExtensions.CSSearchSpringExt.SiteSearch.View'
,	[
        'SiteSearch.View'
    ,   'TavanoTeam.CapSciExtensions.CSSearchSpringExt.ItemsSearcher.View'

    ,   'SC.Configuration'

	,	'tavanoteam_capsciextension_cssearchspringext_sitesearch.tpl'

    ,	'underscore'
    ,   'Backbone.CompositeView'
	,	'jQuery'
	]
,   function (
        SiteSearchView
    ,   SearchSpringItemSearcher

    ,   Configuration

	,	tavanoteam_capsciextension_cssearchspringext_sitesearch_tpl

    ,	_
    ,   BackboneCompositeView
	,	jQuery
	)
{
	'use strict';

	return  {
		loadSearchSpringSiteSearch: function loadSearchSpringSiteSearch (container)
		{
			_.extend(SiteSearchView.prototype, {
                template: tavanoteam_capsciextension_cssearchspringext_sitesearch_tpl
            ,   initialize: _.wrap(SiteSearchView.prototype.initialize, function(fn)
                {
                    var origInit = fn.apply(this, _.toArray(arguments).slice(1));

                    this.itemsSearcherComponent = new SearchSpringItemSearcher({
                        minLength: Configuration.get('typeahead.minLength', 3),
                        maxLength: Configuration.get('searchPrefs.maxLength', 0),
                        limit: Configuration.get('typeahead.maxResults', 10),
                        sort: Configuration.get('typeahead.sort', 'relevance:desc'),
                        highlight: Configuration.get('typeahead.highlight', true)
                    });

                    return origInit;
                })
            , searchEventHandler: function (e) {
                e.preventDefault();

                var search_term = jQuery("input[data-type='search-input']").val();

                if (search_term.length < 1) {
                    return;
                }

                // Function to escape invalid percent sequences
                function escapeInvalidPercentSequences(str) {
                    return str.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
                }

                // Preprocess search_term to escape invalid percent sequences
                search_term = escapeInvalidPercentSequences(search_term);

                this.executeSearch(search_term);

                console.log("jQuery(input[data-type='search-input'])", jQuery("input[data-type='search-input']").val());
            }
            ,   childViews: {
                    ItemsSearcherExt: function()
                    {
                        return this.itemsSearcherComponent;
                    }
                }
            });
		}
	};
});
